const translator = {
    translate(key, replaceValues, languageId) {
        if (!languageId) {
            languageId = sandhills.TradeSites.React.ComponentProps['langID'];
        }
        return this.getTranslation(this.getPlainTextPhrase(key, languageId), replaceValues);
    },
    format(text, replacements) {
        if (replacements != null && replacements.length > 0) {
            for (var i = 0; i < replacements.length; i++) {
                text = text.replace('{' + i + '}', replacements[i]);
            }
        }

        return text;
    },
    getPlainTextPhrase(key, languageId) {
        if (!(key)) key = '';
        key = ('' + key).toLowerCase();
        if (!(languageId)) languageId = sandhills.TradeSites.React.ComponentProps['langID'];
        return (TRANSLATION_LANGUAGES[languageId] && TRANSLATION_LANGUAGES[languageId][key] ? TRANSLATION_LANGUAGES[languageId][key] : '');
    },
    getTranslation(textValue, replaceValues) {
        var temp = [];
        if (replaceValues && replaceValues.length > 0) {
            for (var i = 0; i < replaceValues.length; i++) {
                if (typeof replaceValues[i] == "object" && replaceValues[i].props && replaceValues[i].props.tKey) {
                    if (replaceValues[i].props.replaceValues) {
                        temp.push(this.getTranslation(this.getPlainTextPhrase(replaceValues[i].props.tKey, sandhills.TradeSites.React.ComponentProps['langID']), replaceValues[i].props.replaceValues));
                    }
                    else {
                        temp.push(this.getPlainTextPhrase(replaceValues[i].props.tKey, sandhills.TradeSites.React.ComponentProps['langID']));
                    }
                }
                else {
                    temp.push(replaceValues[i]);
                }
            }
        }
        return this.format(textValue, temp).toString();
    }
};

export default translator;
global.TRANSLATION_LANGUAGES = global.TRANSLATION_LANGUAGES || {};
global.translator = translator; /* This is left because it is called in JS files directly like data-picker.js */